<template>
  <div class="add-prices-pop-up">
    <div v-if="embedType != 'schedule-update'" class="pop-up__close" @click="$emit('close')">
      <img src="@/assets/img/svg/close.svg" alt="close" />
    </div>
    <div v-if="embedType != 'schedule-update'" class="add-prices-pop-up__title">
      {{ isEdit ? translations.titleEdit.text : translations.titleAdd.text }}
    </div>

    <ErrorBanner v-if="isSpacialOfferNow" :errors="[getInfoBannerText]" class="add-prices-pop-up__info-banner" />
    <div v-if="errors || isHaveMinMaxError" class="add-prices-pop-up__errors">
      <div class="add-prices-pop-up__errors--icon">
        <img src="@/assets/img/svg/error.svg" alt="info" />
      </div>
      <div class="add-prices-pop-up__errors--title">
        {{ translations.errorsTitle.text }}
      </div>
      <div v-for="(error, index) in errorsArray" :key="`error-${index}`" class="add-prices-pop-up__errors--error-type">
        <div class="dot dot_bold add-prices-pop-up__errors--dot_red" />
        <div class="add-prices-pop-up__errors--description">
          {{ error.text }}
        </div>
      </div>

      <div v-if="isHaveMinMaxError" class="error-type">
        <div class="dot dot_bold dot_red" />
        <div class="description">{{ translations.bookingInfo.text }}</div>
      </div>
    </div>
    <div v-if="embedType != 'schedule-update'" class="add-prices-pop-up__pricing-title">
      {{ translations.contentPricing.text }}
    </div>
    <div v-if="!tour.is_group_pricing && embedType != 'schedule-update'" class="add-prices-pop-up__tiered-pricing">
      <div class="switcher" @click="priceOptionLocal.tieredPricing = !priceOptionLocal.tieredPricing">
        <Checkbox switcher :checked="priceOptionLocal.tieredPricing" />
      </div>
      <div>{{ translations.switcher.text }}</div>
      <v-question-info :description="translations.tieredPricingQuestion.text" class="text-black" />
    </div>
    <!-- Price -->
    <div v-if="editType != 'times'" class="add-prices-pop-up__block">
      <ErrorBanner
        v-if="hasLiveErrors"
        :errors="errorList"
        class="pop-up-add-prices__error-banner pop-up-add-prices__error-banner--tiered"
      />

      <!-- Person price -->
      <div v-if="!tour.is_group_pricing && !priceOptionLocal.tieredPricing" class="price-option__members-table">
        <div class="price-option__members-row">
          <div class="price-option__members-cell"></div>
          <div class="price-option__members-cell">
            <div v-if="someMemberIsActive" class="price-option__members-subrow">
              <div class="price-option__members-cell">
                {{ translations.pricingRetail.text }}
                <v-question-info :description="translations.pricingRetailQuestion.text" />
              </div>
              <div class="price-option__members-cell">
                {{ translations.pricingGetPaid.text }}
                <v-question-info
                  class="add-prices-pop-up__get-paid"
                  :description="translations.pricingGetPaidQuestion.text"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          v-for="(age, index) in priceOptionLocal.members"
          :key="`age-${age.age_category?.id || age.id}`"
          class="price-option__members-row"
        >
          <div class="price-option__members-cell">
            <Checkbox
              :id="`member-${index}`"
              default
              :name="age.age_category.name"
              :checked="age.is_active"
              @change="changeMember(index, $event)"
            />
          </div>
          <div v-if="age.is_active" class="price-option__members-cell">
            <div class="price-option__members-subrow">
              <div class="price-option__members-cell">
                <v-input2
                  v-model="$v.priceOptionLocal.members.$each.$iter[index].price.$model"
                  :error="isMemberPriceInvalid(priceOptionLocal.members[index])"
                  type="number"
                  class="text-right"
                  onpaste="return false;"
                  prepend-text="EUR"
                  @input="changePrice(index)"
                  @blur="blurPrice(index)"
                />
              </div>
              <div class="price-option__members-cell">
                <v-input :value="showPrice(priceOptionLocal.members[index].feePrice)" prepend-text="EUR" is-disabled />
              </div>
            </div>
          </div>
          <div v-else class="price-option__members-cell">
            <div class="price-option__member-description">
              {{ age.description }}
            </div>
          </div>
        </div>
      </div>
      <!-- Tiered price -->
      <div v-else-if="!tour.is_group_pricing" class="price-option__members-table">
        <div class="price-option__members-row price-option__members-row--tiered">
          <div class="price-option__members-cell"></div>
          <div class="price-option__members-cell price-option__members-cell--tiered">
            <div v-if="someMemberIsActive" class="price-option__members-tiered-subrow">
              <div class="price-option__members-cell">
                {{ translations.pricingTravelerCount?.text || translations.pricingMinMax?.text || 'Traveler count' }}
              </div>
              <div class="price-option__members-cell">
                {{ translations.pricingRetail.text }}
                <v-question-info :description="translations.pricingRetailQuestion.text" />
              </div>
              <div class="price-option__members-cell">
                {{ translations.pricingGetPaid.text }}
                <v-question-info
                  class="add-prices-pop-up__get-paid"
                  :description="translations.pricingRetailQuestion.text"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          v-for="(age, index) in priceOptionLocal.members"
          :key="`age-${age.age_category?.id || age.id}`"
          class="price-option__members-row price-option__members-row--tiered"
        >
          <div class="price-option__members-cell">
            <Checkbox
              :id="`member-${index}`"
              default
              :name="age.age_category.name"
              :checked="age.is_active"
              @change="changeMember(index, $event)"
            />
          </div>
          <div v-if="age.is_active" class="price-option__members-cell price-option__members-cell--tiered">
            <div
              v-for="(ageTieredGroup, ageTieredIndex) in age.ageTieredGroups"
              :key="`ageTieredGroup-${ageTieredIndex}`"
              class="price-option__members-tiered-subrow"
            >
              <div class="price-option__members-cell">
                <!-- minAge используется для минимального количества людей в группе -->
                <v-input
                  v-model="getTieredModel(index, ageTieredIndex).minAge.$model"
                  :error="getTieredModel(index, ageTieredIndex).minAge.$error || ageTieredGroup.minAgeError"
                  type="number"
                  :min="0"
                  :max="getMaxTickets() || 9999"
                  :title="translations?.minimumTravelers?.text || 'Minimum travellers'"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  onpaste="return false;"
                  @input="checkMinAgeCount(index, ageTieredIndex)"
                />
                <span>-</span>
                <!-- maxAge используется для максимального количества людей в группе -->
                <v-input
                  v-model="getTieredModel(index, ageTieredIndex).maxAge.$model"
                  :error="getTieredModel(index, ageTieredIndex).maxAge.$error || ageTieredGroup.maxAgeError"
                  type="number"
                  :min="0"
                  :max="getMaxTickets() || 9999"
                  :title="translations?.maximumTravelers?.text || 'Maximum travellers'"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  onpaste="return false;"
                  @input="checkMinAgeCount(index, ageTieredIndex)"
                />
              </div>
              <div class="price-option__members-cell">
                <v-input2
                  v-model="getTieredModel(index, ageTieredIndex).price.$model"
                  :error="getTieredModel(index, ageTieredIndex).price.$error"
                  type="number"
                  class="text-right"
                  prepend-text="EUR"
                  onpaste="return false;"
                  @input="changePriceTiered(index, ageTieredIndex)"
                  @blur="blurPrice(index, ageTieredIndex)"
                />
              </div>
              <div class="price-option__members-cell">
                <v-input :value="showPrice(ageTieredGroup.feePrice)" prepend-text="EUR" is-disabled />
                <img
                  v-if="ageTieredIndex != 0"
                  src="@/assets/img/svg/del_cross.svg"
                  class="add-prices-pop-up__del-price"
                  @click="removeField(ageTieredIndex, age.ageTieredGroups)"
                />
              </div>
            </div>
            <div class="add-prices-pop-up__add-input" @click="addAgeGroupField(age, age.ageTieredGroups)">
              {{ translations.pricingAddTier.text }}
            </div>
          </div>
          <div v-else class="price-option__members-cell price-option__members-cell--tiered">
            <div class="price-option__member-description">
              {{ age.description }}
            </div>
          </div>
        </div>
      </div>
      <!-- Group price -->
      <div v-else class="price-option__members-table">
        <div class="price-option__members-row price-option__members-row--group">
          <div class="price-option__members-cell">
            {{ translations.maxTravelersPerBooking.text }}
          </div>
          <div class="price-option__members-cell">
            {{ translations.pricingRetail.text }}
            <v-question-info :description="translations.retailPriceQuestionMark.text" />
          </div>
          <div class="price-option__members-cell">
            {{ translations.pricingGetPaid.text }}
            <v-question-info class="add-prices-pop-up__get-paid" :description="translations.getPaidQuestionMark.text" />
          </div>
        </div>
        <div class="price-option__members-row price-option__members-row--group">
          <div class="price-option__members-cell">
            <v-input
              v-model="priceOptionLocal.members[0].groupCount"
              :error="groupPriceCountError"
              class="input-group input-group_count"
              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
              type="number"
              @blur="blurMaxTravelers"
            />
          </div>
          <div class="price-option__members-cell">
            <v-input2
              v-model="$v.priceOptionLocal.members.$each.$iter[0].price.$model"
              :error="$v.priceOptionLocal.members.$each.$iter[0].price.$error"
              type="number"
              class="text-right"
              prepend-text="EUR"
              @input="changePrice(0)"
              @blur="blurPrice(0)"
            />
          </div>
          <div class="price-option__members-cell">
            <v-input :value="showPrice(priceOptionLocal.members[0].feePrice)" prepend-text="EUR" is-disabled />
          </div>
        </div>
      </div>
    </div>
    <!-- Times -->
    <div v-if="editType != 'prices'">
      <!-- Days -->
      <div class="add-prices-pop-up__apply-days">
        <div class="add-prices-pop-up__apply-days--title">
          {{ translations.contentDaysApply.text }}
        </div>
        <div @click="selectAllDays">
          <Checkbox
            id="select-all"
            default
            :name="translations.daysApplySelectAll.text"
            :checked="priceOptionLocal.allDaysChecked"
          />
        </div>
        <div class="add-prices-pop-up__apply-days-content">
          <div
            v-for="(day, index) in priceOptionLocal.days"
            :key="`day-${randomId}-${index}`"
            class="add-prices-pop-up__apply-days-content--item"
            @click="changeDate(index)"
          >
            <Checkbox :id="`day-${randomId}-${index}`" button :name="day.name" :checked="day.is_active" />
          </div>
        </div>
      </div>
      <!-- Apply time -->
      <div v-if="priceOptionLocal.addTimes" class="add-prices-pop-up__apply-time">
        <div class="add-prices-pop-up__apply-time--title">
          {{ translations.contentTimeApply.text }}
        </div>
        <div v-if="embedType != 'schedule-update'" class="add-prices-pop-up__apply-time--note">
          {{ translations.timeApplyNote.text }}
        </div>
        <div class="row">
          <div
            v-for="(time, index) in priceOptionLocal.anotherTimes"
            :key="`time-interval-${index}`"
            class="add-prices-pop-up__apply-time-item row"
          >
            <date-picker
              v-model="time.time"
              type="time"
              :lang="lang"
              :minute-step="5"
              :format="timeFormat"
              class="custom-detepicker"
              :placeholder="translations.timeApplyPlaceholder.text"
              :editable="false"
              @change="newValueApplyTime(index)"
            />
            <div
              v-if="index != 0"
              class="add-prices-pop-up__apply-time-item--delete"
              @click="removeField(index, priceOptionLocal.anotherTimes)"
            >
              <img src="@/assets/img/svg/del_cross.svg" alt="del_cross" />
            </div>
            <div v-if="time.error" class="add-prices-pop-up__apply-time-item--error">
              {{ translations.timeApplyError.text }}
            </div>
          </div>
        </div>
        <span
          v-if="priceOptionLocal.anotherTimes.length < 48"
          class="add-prices-pop-up__add-time"
          @click="addAnotherTimeField(priceOptionLocal.anotherTimes)"
        >
          {{ translations.timeApplyAdd.text }}
        </span>
      </div>
      <!-- Opening time -->
      <div v-if="priceOptionLocal.openingHours" class="add-prices-pop-up__opening-time">
        <div class="add-prices-pop-up__opening-time--title">
          {{ translations.contentTimeApply.text }}
        </div>
        <div
          v-for="(openingScheduleTime, index) in priceOptionLocal.openingScheduleTimes"
          :key="`openingScheduleTime-${index}`"
          class="add-prices-pop-up__opening-time--edit-expand"
        >
          <div class="add-prices-pop-up__edit-expand--item">
            <date-picker
              v-model="openingScheduleTime.startTime"
              type="time"
              :lang="lang"
              :minute-step="5"
              :format="timeFormat"
              :show-second="false"
              class="custom-detepicker"
              :placeholder="translations.openingTimePlaceholderFrom.text"
              :editable="false"
            />
          </div>
          <div class="edit-expand__item">
            <div class="dash">-</div>
          </div>
          <div class="edit-expand__item">
            <date-picker
              v-model="openingScheduleTime.endTime"
              type="time"
              :lang="lang"
              :minute-step="5"
              :format="timeFormat"
              :show-second="false"
              class="custom-detepicker"
              :placeholder="translations.openingTimePlaceholderTo.text"
              :editable="false"
            />
          </div>
          <img
            v-if="index != 0"
            src="@/assets/img/svg/del_cross.svg"
            class="add-prices-pop-up__del-opening-schedule-times"
            @click="removeField(index, priceOptionLocal.openingScheduleTimes)"
          />
        </div>
        <span v-if="false" class="add-prices-pop-up__add-time" @click="addField(priceOptionLocal.openingScheduleTimes)">
          {{ translations.timeApplyAdd.text }}
        </span>
      </div>
    </div>
    <div v-if="specialOfferError" class="add-prices-pop-up__spacial-offer-error">
      {{ translations.pricesCannotBeSaved.text }}
    </div>
    <div v-if="embedType != 'schedule-update'" class="add-prices-pop-up__nav">
      <v-btn outline :name="translations.backBtn.text" @click="$emit('back')" />
      <div v-if="step > 0" class="pagination row">
        <div v-if="step == 3" class="dot dot_page" />
        <div class="dot dot_page" />
        <div class="dot dot_page dot_page_active" />
      </div>
      <v-btn base :name="translations.saveBtn.text" :disabled="isSpacialOfferNow" @click="save" />
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { required, requiredIf, minValue, maxValue } from 'vuelidate/lib/validators'
  import DatePicker from 'vue2-datepicker'
  import 'vue2-datepicker/index.css'
  import 'vue2-datepicker/locale/es'
  import VBtn from '@/components/controls/VBtn.vue'
  import VInput from '@/components/controls/VInput.vue'
  import VInput2 from '@/components/controls/VInput2.vue'
  import Checkbox from '@/components/controls/Checkbox.vue'
  import ErrorBanner from '@/components/ErrorBanner.vue'
  import VQuestionInfo from '@/components/common/VQuestionInfo.vue'

  import { format, getDayNames } from '@/utils/date'
  import { isAdultOrSenior, getAgeTieredGroupsDefault, getPriceFee, FREE_CHILDREN_CATEGORIES } from '@/utils/price'
  import { parseTranslate } from '@/utils/translations'
  import { formatCurrency, formatTime } from '@/utils/utils'

  const MIN_PRICE = 2.99
  const MAX_PRICE = 99999999999999
  const MIN_TRAVELERS = 1
  const MAX_TRAVELERS = 9999
  const DAYS_30 = 30 * 86400 * 1000

  export default {
    components: {
      VBtn,
      Checkbox,
      DatePicker,
      VInput,
      VInput2,
      ErrorBanner,
      VQuestionInfo,
    },
    props: {
      isEdit: { type: Boolean, default: false },
      tour: { type: Object, default: () => ({}) },
      translations: { type: Object, default: () => ({}) },
      priceOption: { type: Object, default: () => ({}) },
      step: { type: Number, default: 0 },
      editType: { type: String, default: '' },
      embedType: { type: String, default: '' },
    },
    data() {
      return {
        randomId: Math.floor(Math.random() * 100000) + 1,
        priceOptionLocal: {
          members: [],
          openingHours: false,
          addTimes: false,
          anotherTimes: [{ time: null, is_active: false }],
          openingScheduleTimes: [{ startTime: null, endTime: null }],
          days: [
            { name: 'Mon', day: '1', is_active: false },
            { name: 'Tue', day: '2', is_active: false },
            { name: 'Wed', day: '3', is_active: false },
            { name: 'Thu', day: '4', is_active: false },
            { name: 'Fri', day: '5', is_active: false },
            { name: 'Sat', day: '6', is_active: false },
            { name: 'Sun', day: '7', is_active: false },
          ],
          activeDaysCount: 0,
          allDaysChecked: false,
          tieredPricing: false,
        },
        errors: false,
        errorsArray: [],
        isHaveMinMaxError: false,
        groupPriceCountError: false,
        isHavePriceError: false,
        priceError: [],
        isHaveMaxTravelersError: false,
        maxTravelersError: [],
        isHaveMinPriceError: false,
        isHaveMaxPriceError: false,
        // Ошибки валидации количества людей в tiered pricing (ранее назывались "age")
        isHaveAgeError: false,
        isHaveAgeIntervalError: false,
        ageError: [],
        specialOfferError: false,
        specialOfferMinPriceError: false,
        lang: '',
        submitting: false,
        isHaveInitialMinSumError: false,
        initialMinSumError: [],
      }
    },

    fetch() {
      this.lang = this.$cookies.get('i18n_redirected')
      // WARN! Не трогать, попытка исправить это приведёт к непредсказуемым багам
      this.priceOptionLocal = this.priceOption
      this.normalizeMemberPrices()
      const dayNames = getDayNames(this.lang)
      this.priceOptionLocal.days.forEach((day, idx) => (day.name = dayNames[idx]))

      this.$nextTick(() => {
        if (this.priceOptionLocal.tieredPricing) {
          this.recomputeTravelerRangesErrors()
          this.checkInitialMinSum()
        }
      })
    },

    computed: {
      ...mapState(['userInfo']),

      hasLiveErrors() {
        if (this.submitting) return false
        const anyPrice = this.priceError.length > 0
        const anyAge = this.ageError.length > 0
        const anyMaxTrav = !this.priceOptionLocal.tieredPricing && this.maxTravelersError.length > 0
        const initialMinProblem = this.initialMinSumError.length > 0
        return anyPrice || anyAge || anyMaxTrav || initialMinProblem
      },

      maxTravelers() {
        const n = Number(this.tour?.max_travelers_per_booking)
        return Number.isFinite(n) ? n : 0
      },

      minPriceError() {
        if (this.$v.priceOptionLocal.members.$anyError) {
          return parseTranslate(this.translations.suggestedRetailPriceGreaterError.text, MIN_PRICE)
        }
        return ''
      },

      isSpacialOfferNow() {
        const dateNow = new Date()
        dateNow.setHours(0, 0, 0, 0)
        return dateNow <= new Date(this.tour.discount_info[0]?.discount_end_date)
      },

      getInfoBannerText() {
        const start = format(this.tour.discount_info[0]?.discount_start_date, 'do MMMM yyy', this.lang)
        const end = format(this.tour.discount_info[0]?.discount_end_date, 'do MMMM yyy', this.lang)
        return parseTranslate(this.translations.errorIntroOffer.text, start, end)
      },

      errorList() {
        if (!this.submitting) {
          const arr = [...this.priceError]
          if (!this.priceOptionLocal.tieredPricing) arr.push(...this.maxTravelersError)
          // Показываем ageError во время редактирования только если есть реальные структурные ошибки (gap/overlap)
          if (this.ageError.length) arr.push(...this.ageError)
          if (this.initialMinSumError.length) arr.push(...this.initialMinSumError)
          return arr
        }
        return [...this.priceError, ...this.maxTravelersError, ...this.ageError, ...this.initialMinSumError]
      },

      someMemberIsActive() {
        return this.priceOptionLocal.members.some((m) => m.is_active)
      },

      timeFormat() {
        return formatTime({ lang: this.lang })
      },
    },
    watch: {
      'priceOptionLocal.tieredPricing'(isTiered) {
        this.$nextTick(() => {
          if (this.$v && this.$v.$reset) this.$v.$reset()
          this.priceError = []
          this.isHavePriceError = false
          this.isHaveMinPriceError = false
          this.isHaveMaxPriceError = false
          this.ageError = []
          this.isHaveAgeError = false
          this.isHaveAgeIntervalError = false
          this.errors = false
          this.normalizeMemberPrices()
          if (isTiered) this.recomputeTravelerRangesErrors()
        })
      },
    },
    validations() {
      if (this.priceOptionLocal.tieredPricing) {
        return {
          priceOptionLocal: {
            members: {
              $each: {
                ageTieredGroups: {
                  $each: {
                    price: {
                      required: requiredIf(
                        (field) =>
                          this.getAgeCategoryById(field.ageCategoryId).is_active &&
                          this.checkAdultsOrSeniorById(field.ageCategoryId)
                      ),
                      // Валидация цены для групп с включенным Tiered pricing
                      minValue: (value, field) => {
                        const group = this.getAgeCategoryById(field.ageCategoryId)
                        if (!group.is_active) return true
                        if (
                          FREE_CHILDREN_CATEGORIES.has(field.ageCategoryId) &&
                          this.normalizeNumber(value) === 0
                        )
                          return true
                        const priceValue = this.normalizeNumber(value)
                        if (!Number.isFinite(priceValue)) return false
                        return priceValue >= MIN_PRICE
                      },
                      maxValue: (value, field) =>
                        this.getAgeCategoryById(field.ageCategoryId).is_active
                          ? maxValue(MAX_PRICE)(this.normalizeNumber(value))
                          : true,
                    },

                    minAge: {
                      required: requiredIf(
                        (field) =>
                          this.getAgeCategoryById(field.ageCategoryId).is_active &&
                          this.checkAdultsOrSeniorById(field.ageCategoryId)
                      ),
                      minValue: (value, field) =>
                        this.getAgeCategoryById(field.ageCategoryId).is_active ? minValue(0)(Number(value)) : true,
                      maxValue: (value, field) =>
                        this.getAgeCategoryById(field.ageCategoryId).is_active
                          ? maxValue(this.getMaxTickets() || MAX_TRAVELERS)(Number(value))
                          : true,
                      // Минимум должен быть меньше максимума в той же группе
                      lessThanMax: (value, field) => {
                        if (!this.getAgeCategoryById(field.ageCategoryId).is_active) return true
                        const maxVal = Number(field.maxAge)
                        const minVal = Number(value)
                        if (!Number.isFinite(maxVal) || !Number.isFinite(minVal)) return true
                        // Разрешаем равенство только если это последняя группа и min==max==глобальный максимум
                        try {
                          const globalMax = this.getMaxTickets() || MAX_TRAVELERS
                          const member = this.priceOptionLocal.members.find(
                            (m) => m.ageTieredGroups && m.ageTieredGroups.includes(field)
                          )
                          if (member) {
                            const idx = member.ageTieredGroups.indexOf(field)
                            const isLast = idx === member.ageTieredGroups.length - 1
                            if (isLast && minVal === maxVal && maxVal === Number(globalMax)) return true
                          }
                        } catch (e) {}
                        return minVal < maxVal
                      },
                      // Должен следовать сразу после предыдущего максимума (без пропусков)
                      noGaps: (value, field) => {
                        if (!this.getAgeCategoryById(field.ageCategoryId).is_active) return true
                        try {
                          // Ищем соответствующую группу в локальных данных (без обращения к vm.$model)
                          const member = this.priceOptionLocal.members.find(
                            (m) => m.ageTieredGroups && m.ageTieredGroups.includes(field)
                          )
                          if (!member || !member.ageTieredGroups) return true
                          const idx = member.ageTieredGroups.indexOf(field)
                          // первая группа может начинаться с любого min (в т.ч. 0)
                          if (idx === 0) return true
                          const prev = member.ageTieredGroups[idx - 1]
                          if (!prev || prev.maxAge === '' || prev.maxAge == null) return true
                          return Number(value) === Number(prev.maxAge) + 1
                        } catch (e) {
                          return true
                        }
                      },
                    },

                    maxAge: {
                      // maxAge на самом деле означает максимальное количество людей в группе
                      required: requiredIf(
                        (field) =>
                          this.getAgeCategoryById(field.ageCategoryId).is_active &&
                          this.checkAdultsOrSeniorById(field.ageCategoryId)
                      ),
                      minValue: (value, field) =>
                        this.getAgeCategoryById(field.ageCategoryId).is_active ? minValue(0)(Number(value)) : true,
                      maxValue: (value, field) =>
                        this.getAgeCategoryById(field.ageCategoryId).is_active
                          ? maxValue(this.getMaxTickets() || MAX_TRAVELERS)(Number(value))
                          : true,
                      // Максимум должен быть больше минимума в той же группе
                      greaterThanMin: (value, field) => {
                        if (!this.getAgeCategoryById(field.ageCategoryId).is_active) return true
                        const minVal = Number(field.minAge)
                        const maxVal = Number(value)
                        if (!Number.isFinite(minVal) || !Number.isFinite(maxVal)) return true
                        // Разрешаем равенство для последней группы, если min==max==глобальный максимум
                        try {
                          const globalMax = this.getMaxTickets() || MAX_TRAVELERS
                          const member = this.priceOptionLocal.members.find(
                            (m) => m.ageTieredGroups && m.ageTieredGroups.includes(field)
                          )
                          if (member) {
                            const idx = member.ageTieredGroups.indexOf(field)
                            const isLast = idx === member.ageTieredGroups.length - 1
                            if (isLast && minVal === maxVal && maxVal === Number(globalMax)) return true
                          }
                        } catch (e) {}
                        return maxVal > minVal
                      },
                      // Максимум не должен пересекаться со следующим минимумом
                      noOverlap: (value, field) => {
                        if (!this.getAgeCategoryById(field.ageCategoryId).is_active) return true
                        try {
                          const member = this.priceOptionLocal.members.find(
                            (m) => m.ageTieredGroups && m.ageTieredGroups.includes(field)
                          )
                          if (!member || !member.ageTieredGroups) return true
                          const currentIndex = member.ageTieredGroups.indexOf(field)
                          const nextGroup = member.ageTieredGroups[currentIndex + 1]
                          if (!nextGroup) return true
                          // важно: 0 валиден, поэтому проверяем только на ''/null
                          if (nextGroup.minAge === '' || nextGroup.minAge == null) return true
                          return Number(value) < Number(nextGroup.minAge)
                        } catch (e) {
                          return true
                        }
                      },
                      // Последний диапазон должен оканчиваться глобальным максимумом (полное покрытие)
                      fullCoverage: (value, field) => {
                        if (!this.getAgeCategoryById(field.ageCategoryId).is_active) return true
                        const globalMax = this.getMaxTickets() || MAX_TRAVELERS
                        try {
                          const member = this.priceOptionLocal.members.find(
                            (m) => m.ageTieredGroups && m.ageTieredGroups.includes(field)
                          )
                          if (!member || !member.ageTieredGroups) return true
                          const groups = member.ageTieredGroups
                          const idx = groups.indexOf(field)
                          // Отложим проверку, если value пустой (пусть сработает required) или диапазон ещё редактируют
                          if (value === '' || value == null) return true
                          // Проверяем, что ВСЕ группы заполнены полностью (оба конца заданы и валидны численно)
                          const allComplete = groups.every(
                            (g) => g.minAge !== '' && g.minAge != null && g.maxAge !== '' && g.maxAge != null
                          )
                          if (!allComplete) return true
                          if (idx === groups.length - 1) return Number(value) === Number(globalMax)
                          return true
                        } catch (e) {
                          return true
                        }
                      },
                      // Верхняя граница по лимиту людей на бронирование из тура (0 = без лимита)
                      maxByTravelers: (value) => {
                        const limit = this.maxTravelers
                        if (!limit) return true
                        if (value === '' || value == null) return true
                        return Number(value) <= Number(limit)
                      },
                    },
                  },
                },
              },
            },
          },
        }
      }
      if (this.tour.is_group_pricing) {
        return {
          priceOptionLocal: {
            members: {
              $each: {
                groupCount: {
                  required,
                  minValue: (value) => minValue(MIN_TRAVELERS)(Number(value)),
                  maxValue: (value) => maxValue(MAX_TRAVELERS)(Number(value)),
                },
                price: {
                  required,
                  minValue: (value) => minValue(MIN_PRICE)(this.normalizeNumber(value)),
                  maxValue: (value) => maxValue(MAX_PRICE)(this.normalizeNumber(value)),
                },
              },
            },
          },
        }
      }
      return {
        // Данные поля отвечают за возрастные группы без Tiered pricing
        priceOptionLocal: {
          members: {
            $each: {
            price: {
              required: requiredIf((field) => field.is_active && this.isAdultOrSenior(field)),
              minValue: (field, member) => {
                if (!member.is_active) return true
                if (
                  FREE_CHILDREN_CATEGORIES.has(member.age_category.id) &&
                  this.normalizeNumber(field) === 0
                )
                  return true
                const priceValue = this.normalizeNumber(field)
                if (!Number.isFinite(priceValue)) return false
                return priceValue >= MIN_PRICE
              },
              maxValue: (field, member) =>
                member.is_active ? maxValue(MAX_PRICE)(this.normalizeNumber(field)) : true,
            },
            },
          },
        },
      }
    },

    methods: {
      isAdultOrSenior,

      // ================================
      // Хелперы для диапазонов количества путешественников (ранее поле называлось "age")
      // Почему до сих пор minAge / maxAge в данных:
      // 1) Бэкенд и общие утилиты (utils/price::checkAge) ждут именно эти ключи.
      // 2) Полное переименование требует согласованных изменений API и общих модулей.
      // Для читабельности в голове трактуем их так:
      //   minAge -> minCount (минимум людей в этом тарифном диапазоне)
      //   maxAge -> maxCount (максимум людей в этом тарифном диапазоне)
      // Когда-нибудь можем мигрировать API и сделать адаптер:
      //  - При получении: преобразовать min_age -> minCount
      //  - Внутри компонента работать только с minCount/maxCount
      //  - Перед сохранением обратно маппить на старые ключи
      // Сейчас оставляем имена полей как есть, ограничиваемся методами и комментариями.

      resetTravelerRangeErrors() {
        this.ageError = []
        this.isHaveAgeError = false
        this.isHaveAgeIntervalError = false
        this.priceOptionLocal.members.forEach((m) => {
          if (m.ageTieredGroups) {
            m.ageTieredGroups.forEach((g) => {
              g.minAgeError = false
              g.maxAgeError = false
            })
          }
        })
      },

      // Перезапускает проверку всех диапазонов для всех активных членов
      recomputeTravelerRangesErrors() {
        this.ageError = []
        this.isHaveAgeError = false
        this.isHaveAgeIntervalError = false
        for (let i = 0; i < this.priceOptionLocal.members.length; i++) {
          const m = this.priceOptionLocal.members[i]
          if (m.is_active && Array.isArray(m.ageTieredGroups)) {
            for (let j = 0; j < m.ageTieredGroups.length; j++) {
              this.checkMinAgeCount(i, j)
            }
          }
        }
        this.checkInitialMinSum()
      },

      // Обёртка для обратной совместимости (шаблон продолжает вызывать старое имя)
      checkMinAgeCount(index, tierIndex) {
        return this.checkTravelerRange(index, tierIndex)
      },

      // Унифицированный анализ диапазонов одной категории. Возвращает метаданные и агрегированные флаги.
      validateTravelerRanges(groups, globalMax) {
        const meta = []
        let structural = false
        let coverageMissing = false
        let exceedLimit = false
        const allComplete = groups.every(
          (g) => g && g.minAge !== '' && g.minAge != null && g.maxAge !== '' && g.maxAge != null
        )

        for (let i = 0; i < groups.length; i++) {
          const g = groups[i]
          if (!g) continue
          const prev = groups[i - 1]
          const res = { index: i, code: 'ok', message: '', hint: '' }
          const hasMin = g.minAge !== '' && g.minAge != null
          const hasMax = g.maxAge !== '' && g.maxAge != null
          const minVal = Number(g.minAge)
          const maxVal = Number(g.maxAge)

          // Незаполненные состояния
          if (hasMin && !hasMax) {
            res.code = 'editingIncomplete'
            res.hint = this.translations?.travelerRangeEnterMax?.text || 'Enter max'
            meta.push(res)
            continue
          }
          if (!hasMin && hasMax) {
            res.code = 'editingIncomplete'
            res.hint = this.translations?.travelerRangeEnterMin?.text || 'Enter min'
            meta.push(res)
            continue
          }
          if (!hasMin && !hasMax) {
            res.code = 'empty'
            if (i === 0) res.hint = this.translations?.travelerRangeEnterMin?.text || 'Enter min'
            meta.push(res)
            continue
          }

          // Лимиты
          if (minVal > globalMax || maxVal > globalMax) {
            res.code = 'exceedLimit'
            exceedLimit = true
            res.message = parseTranslate(
              this.translations?.travelerCountExceedsLimit?.text ||
                'Please enter a maximum number of travelers less than or equal to {0}.',
              globalMax
            )
            structural = true
            meta.push(res)
            continue
          }

          const isLast = i === groups.length - 1
          const finalSingle = isLast && minVal === maxVal && maxVal === Number(globalMax)

          if (maxVal < minVal && !finalSingle) {
            res.code = 'ordering'
            res.message =
              this.translations?.travelerRangeOrderError?.text ||
              'Please enter a maximum number of travelers greater than or equal to the minimum.'
            structural = true
            meta.push(res)
            continue
          }

          if (i > 0) {
            const prevMax = Number(prev.maxAge)
            if (prevMax === Number(globalMax)) {
              res.code = 'terminated'
              res.message = parseTranslate(
                this.translations?.travelerRangeAfterLimitNotAllowed?.text || 'No ranges allowed after {0}',
                globalMax
              )
              structural = true
              meta.push(res)
              continue
            }
            if (minVal <= prevMax) {
              res.code = 'overlap'
              res.message = this.translations?.travelerRangeOverlapError?.text || 'Ranges must not overlap'
              structural = true
            } else if (minVal > prevMax + 1) {
              res.code = 'gap'
              res.message =
                this.translations?.travelerRangeGapError?.text ||
                'Please enter a minimum number of travelers that is one greater than the maximum of the previous tier.'
              structural = true
            }
          }

          if (finalSingle && res.code === 'ok') res.code = 'finalSingleOk'
          meta.push(res)
        }

        if (allComplete) {
          const lastMeta = meta[meta.length - 1]
          const lastGroup = groups[groups.length - 1]
          if (lastGroup && Number(lastGroup.maxAge) !== Number(globalMax)) {
            coverageMissing = true
            if (lastMeta && !lastMeta.message && lastMeta.code !== 'exceedLimit') {
              lastMeta.code = 'coverage'
              lastMeta.message = parseTranslate(
                this.translations?.travelerRangeFullCoverage?.text || 'Last range must end at {0}.',
                globalMax
              )
            }
          }
        }

        return { meta, structural, coverageMissing, exceedLimit }
      },

      checkTravelerRange(index, tieredIndex) {
        this._rangeValidationActive = true
        const globalMax = this.getMaxTickets() || MAX_TRAVELERS
        const member = this.priceOptionLocal.members[index]
        if (!member || !Array.isArray(member.ageTieredGroups)) return
        const groups = member.ageTieredGroups
        // Ранний выход для стабильно финального одноточечного диапазона
        try {
          const last = groups[groups.length - 1]
          if (
            tieredIndex === groups.length - 1 &&
            last &&
            last.minAge !== '' &&
            last.maxAge !== '' &&
            Number(last.minAge) === Number(last.maxAge) &&
            Number(last.maxAge) === Number(globalMax) &&
            this._lastFinalRangeValue === `${last.minAge}-${last.maxAge}`
          ) {
            this.checkInitialMinSum()
            return
          }
        } catch (e) {}

        const { meta, structural, coverageMissing, exceedLimit } = this.validateTravelerRanges(groups, globalMax)
        // Сброс локальных флагов
        groups.forEach((g) => {
          g.minAgeError = false
          g.maxAgeError = false
        })
        const errorCodes = new Set([
          'ordering',
          'overlap',
          'gap',
          'duplicateStart',
          'exceedLimit',
          'coverage',
          'terminated',
        ])
        meta.forEach((m) => {
          const g = groups[m.index]
          if (!g) return
          if (errorCodes.has(m.code)) {
            g.minAgeError = true
            g.maxAgeError = true
          }
        })

        this.isHaveAgeIntervalError = structural || coverageMissing || exceedLimit
        this.ageError = []
        if (this.isHaveAgeIntervalError) {
          const priority = ['exceedLimit', 'ordering', 'overlap', 'gap', 'duplicateStart', 'coverage', 'terminated']
          const first = meta
            .filter((m) => m.message)
            .sort((a, b) => priority.indexOf(a.code) - priority.indexOf(b.code))[0]
          if (first && first.message) this.ageError.push(first.message)
        } else {
          const hint = meta.find((m) => m.hint)?.hint
          if (hint) this.ageError.push(hint)
        }
        // Cache финального шаблона
        try {
          const last = groups[groups.length - 1]
          if (last) this._lastFinalRangeValue = `${last.minAge}-${last.maxAge}`
        } catch (e) {}

        this.checkInitialMinSum()
        this.errors = false
      },

      getTieredModel(ageIndex, countIndex) {
        return this.$v.priceOptionLocal.members.$each.$iter[ageIndex].ageTieredGroups.$each.$iter[countIndex]
      },

      getMaxTickets() {
        return this.tour?.max_travelers_per_booking || 0
      },

      normalizeNumber(value) {
        if (value == null || value === '') return NaN
        const normalized = String(value)
          .replace(/\s/g, '')
          .replace(',', '.')
          .replace(/[^\d.-]/g, '')
        if (normalized === '' || normalized === '-' || normalized === '.') return NaN
        const num = Number(normalized)
        return Number.isFinite(num) ? num : NaN
      },

      normalizeMemberPrices() {
        if (!Array.isArray(this.priceOptionLocal.members)) return
        this.priceOptionLocal.members.forEach((member) => {
          const normalizedPrice = this.normalizeNumber(member.price)
          if (Number.isFinite(normalizedPrice)) member.price = normalizedPrice.toFixed(2)
          if (Array.isArray(member.ageTieredGroups)) {
            member.ageTieredGroups.forEach((group) => {
              const normalizedTierPrice = this.normalizeNumber(group.price)
              if (Number.isFinite(normalizedTierPrice)) group.price = normalizedTierPrice.toFixed(2)
            })
          }
        })
      },

      // Метод для получения подходящего сообщения об ошибке количества людей
      getTravelerCountErrorMessage() {
        const maxTickets = this.getMaxTickets() || MAX_TRAVELERS
        const text =
          this.translations.travelerCountError?.text ||
          this.translations.ageError?.text ||
          'Traveler count must be between {0} and {1}. Ranges must be continuous without gaps.'
        return parseTranslate(text, 0, maxTickets)
      },

      showPrice(n) {
        if (n == null) return n
        return formatCurrency(n, this.lang, 'none')
      },

      checkAdultsOrSeniorById(id) {
        const member = this.getAgeCategoryById(id)
        return this.isAdultOrSenior(member)
      },

      isMemberPriceInvalid(member) {
        if (!member?.is_active) return false
        const priceValue = this.normalizeNumber(member.price)
        if (!Number.isFinite(priceValue)) {
          return this.isAdultOrSenior(member)
        }
        if (FREE_CHILDREN_CATEGORIES.has(member.age_category.id) && priceValue === 0) return false
        return priceValue < MIN_PRICE || priceValue > MAX_PRICE
      },

      recomputePriceErrorsNonTiered() {
        this.priceError = []
        this.isHavePriceError = false
        this.isHaveMinPriceError = false
        this.isHaveMaxPriceError = false
        for (let i = 0; i < this.priceOptionLocal.members.length; i++) {
          const member = this.priceOptionLocal.members[i]
          if (!member?.is_active) continue
          const priceValue = this.normalizeNumber(member.price)
          if (!Number.isFinite(priceValue)) {
            if (this.isAdultOrSenior(member)) {
              this.isHaveMinPriceError = true
              this.priceError.push(parseTranslate(this.translations.suggestedRetailPriceGreaterError.text, MIN_PRICE))
              break
            }
            continue
          }
          if (FREE_CHILDREN_CATEGORIES.has(member.age_category.id) && priceValue === 0) continue
          if (priceValue < MIN_PRICE) {
            this.isHaveMinPriceError = true
            this.priceError.push(parseTranslate(this.translations.suggestedRetailPriceGreaterError.text, MIN_PRICE))
            break
          }
          if (priceValue > MAX_PRICE) {
            this.isHaveMaxPriceError = true
            this.priceError.push(parseTranslate(this.translations.suggestedRetailPriceLessError.text, MAX_PRICE))
            break
          }
        }
      },

      getAgeCategoryById(id) {
        return this.priceOptionLocal.members.find((m) => m.age_category.id === id)
      },

      selectAllDays() {
        const selectAll = document.getElementById('select-all')
        const checked = !!selectAll.checked
        for (const index in this.priceOptionLocal.days) {
          document.getElementById(`day-${this.randomId}-${index}`).checked = checked
          this.priceOptionLocal.days[index].is_active = checked
        }
      },

      changeDate(index) {
        this.priceOptionLocal.days[index].is_active = document.getElementById(`day-${this.randomId}-${index}`).checked
        this.priceOptionLocal.activeDaysCount = 0
        for (const i in this.priceOptionLocal.days) {
          if (this.priceOptionLocal.days[i].is_active) this.priceOptionLocal.activeDaysCount += 1
        }
        this.priceOptionLocal.allDaysChecked = this.priceOptionLocal.activeDaysCount === 7
      },

      changePriceTiered(index, tieredIndex) {
        const priceValue = this.normalizeNumber(this.priceOptionLocal.members[index].ageTieredGroups[tieredIndex].price)
        if (Number.isFinite(priceValue)) {
          this.priceOptionLocal.members[index].ageTieredGroups[tieredIndex].price = String(priceValue)
        }
        const newFee = getPriceFee(Number.isFinite(priceValue) ? priceValue : 0, this.userInfo.commission_amount)
        this.priceOptionLocal.members[index].ageTieredGroups[tieredIndex].feePrice = newFee
        this.$nextTick(() => {
          this.priceError = []
          this.isHavePriceError = false
          this.isHaveMinPriceError = false
          this.isHaveMaxPriceError = false
          for (let i = 0; i < this.priceOptionLocal.members.length; i++) {
            if (this.priceOptionLocal.members[i].is_active) {
              for (let j = 0; j < this.priceOptionLocal.members[i].ageTieredGroups.length; j++) {
              this.checkPriceError(
                this.$v.priceOptionLocal.members.$each.$iter[i].ageTieredGroups.$each.$iter[j]
              )
              }
            }
          }
        })
      },

      changeMember(index, isActive) {
        if (!this.priceOptionLocal.members[index]) return
        this.$set(this.priceOptionLocal.members[index], 'is_active', !!isActive)
        this.checkInitialMinSum()
        this.errors = false
      },

      blurMaxTravelers() {
        const oldValue = this.priceOptionLocal.members[0].groupCount
        if (!this.tour.is_private && oldValue > 0) {
          this.priceOptionLocal.members[0].groupCount = Math.min(oldValue, this.tour.max_travelers)
        }
      },

      blurPrice(index, groupIndex = undefined) {
        const field =
          typeof groupIndex === 'number'
            ? this.priceOptionLocal.members[index].ageTieredGroups[groupIndex]
            : this.priceOptionLocal.members[index]
        const value = this.normalizeNumber(field.price) || 0
        field.price = value.toFixed(2)
      },

      changePrice(index) {
        const priceValue = this.normalizeNumber(this.priceOptionLocal.members[index].price)
        if (Number.isFinite(priceValue)) {
          this.priceOptionLocal.members[index].price = String(priceValue)
        }
        const newFee = getPriceFee(Number.isFinite(priceValue) ? priceValue : 0, this.userInfo.commission_amount)
        this.priceOptionLocal.members[index].feePrice = newFee
        this.$nextTick(() => {
          this.priceError = []
          this.isHavePriceError = false
          this.isHaveMinPriceError = false
          this.isHaveMaxPriceError = false
          if (this.tour.is_group_pricing) this.checkRetailPrice()
          else this.recomputePriceErrorsNonTiered()
        })
      },

      removeField(index, fieldType) {
        fieldType.splice(index, 1)

        // Если это был tiered group, перепроверяем валидацию
        if (
          this.priceOptionLocal.tieredPricing &&
          fieldType === this.priceOptionLocal.members.find((m) => m.ageTieredGroups === fieldType)?.ageTieredGroups
        ) {
          this.$nextTick(() => {
            // Сбрасываем ошибки
            this.ageError = []
            this.isHaveAgeError = false
            this.isHaveAgeIntervalError = false

            // Перепроверяем оставшиеся группы
            for (let i = 0; i < this.priceOptionLocal.members.length; i++) {
              if (this.priceOptionLocal.members[i].is_active && this.priceOptionLocal.members[i].ageTieredGroups) {
                for (let j = 0; j < this.priceOptionLocal.members[i].ageTieredGroups.length; j++) {
                  this.checkMinAgeCount(i, j)
                }
              }
            }
          })
        }
      },

      addAnotherTimeField(fieldType) {
        fieldType.push({ time: null, is_active: false })
      },

      addAgeGroupField(age, fieldType) {
        if (!age) return
        if (!Array.isArray(fieldType)) {
          this.$set(age, 'ageTieredGroups', [])
          fieldType = age.ageTieredGroups
        }
        const globalMax = this.getMaxTickets() || MAX_TRAVELERS
        if (fieldType.length === 0) {
          const g = getAgeTieredGroupsDefault(age.age_category.id)
          g.minAge = 0
          g.maxAge = globalMax
          fieldType.push(g)
          this.$nextTick(() => this.recomputeTravelerRangesErrors())
          return
        }

        const last = fieldType[fieldType.length - 1]
        const lastMax = Number(last.maxAge)

        // Если единственная группа и она не покрывает максимум — расширяем добавляя продолжение (min = lastMax+1, max=global)
        if (fieldType.length === 1 && lastMax && lastMax < globalMax) {
          const g = getAgeTieredGroupsDefault(age.age_category.id)
          g.minAge = lastMax + 1
          g.maxAge = globalMax
          fieldType.push(g)
          this.$nextTick(() => this.recomputeTravelerRangesErrors())
          return
        }

        // Если последняя покрывает максимум — сплит: очищаем её max, добавляем новую с max=globalMax
        if (lastMax && lastMax === globalMax) {
          last.maxAge = '' // пользователь задаст новый максимум предыдущей части
          const g = getAgeTieredGroupsDefault(age.age_category.id)
          g.minAge = '' // будет автозаполнен после ввода предыдущего max
          g.maxAge = globalMax
          fieldType.push(g)
          this.$nextTick(() => this.recomputeTravelerRangesErrors())
          return
        }

        // Иначе — стандарт: новая группа от (lastMax+1) до globalMax
        const g = getAgeTieredGroupsDefault(age.age_category.id)
        g.minAge = lastMax ? lastMax + 1 : ''
        g.maxAge = globalMax
        fieldType.push(g)
        this.$nextTick(() => this.recomputeTravelerRangesErrors())
      },

      newValueApplyTime(index) {
        const entry = this.priceOptionLocal.anotherTimes[index]
        if (!entry) return
        if (!entry.time) {
          entry.error = true
          return
        }
        const val = new Date(entry.time).toLocaleTimeString()
        // Помечаем активным
        entry.is_active = true
        // Проверка дублей
        const duplicate = this.priceOptionLocal.anotherTimes.some((t, i) => {
          if (i === index || !t.time) return false
          try {
            return new Date(t.time).toLocaleTimeString() === val
          } catch (e) {
            return false
          }
        })
        entry.error = duplicate
      },

      checkSpacialOffer(member) {
        const timeHasPassedSinceEndDiscount =
          new Date().getTime() - new Date(this.tour.discount_info[0]?.discount_end_date).getTime()
        this.specialOfferMinPriceError =
          timeHasPassedSinceEndDiscount < DAYS_30 && Number(member.price) < Number(this.tour.price_without_discount)
        return this.specialOfferMinPriceError
      },

      checkRetailPrice() {
        this.priceError = []
        this.isHavePriceError = false
        // Используется для group pricing (members[0]) и обычного режима без tiered
        const vMember0 = this.$v?.priceOptionLocal?.members?.$each?.$iter?.[0]
        if (vMember0 && vMember0.price && vMember0.price.$anyError) {
          this.isHavePriceError = true
          if (!vMember0.price.required || !vMember0.price.minValue)
            this.priceError.push(parseTranslate(this.translations.suggestedRetailPriceGreaterError.text, MIN_PRICE))
          else if (!vMember0.price.maxValue)
            this.priceError.push(parseTranslate(this.translations.suggestedRetailPriceLessError.text, MAX_PRICE))
        }
      },

      _getFirstRangeMin(member) {
        if (!member || !member.is_active) return 0
        const g0 = Array.isArray(member.ageTieredGroups) ? member.ageTieredGroups[0] : null
        if (!g0) return 0
        const v = Number(g0.minAge)
        return Number.isFinite(v) ? v : 0
      },

      checkInitialMinSum() {
        this.isHaveInitialMinSumError = false
        this.initialMinSumError = []
        if (!this.priceOptionLocal?.tieredPricing) return

        const limit = Number(this.getMaxTickets() || this.maxTravelers || 0)
        if (!limit) return

        let sum = 0
        for (const m of this.priceOptionLocal.members || []) {
          if (!m?.is_active) continue
          sum += this._getFirstRangeMin(m)
        }

        if (sum > limit) {
          this.isHaveInitialMinSumError = true
          const msg =
            this.translations?.initialMinSumExceedsLimit?.text ||
            'The sum of the minimums per booking across all age groups ({0}) cannot exceed your maximum travelers of {1}. You can change your maximum travelers in Booking details.'
          this.initialMinSumError.push(parseTranslate(msg, sum, limit))
        }
      },

      checkMaxTravelersError() {
        this.maxTravelersError = []
        this.isHaveMaxTravelersError = false
        const vMember0 = this.$v?.priceOptionLocal?.members?.$each?.$iter?.[0]
        if (vMember0 && vMember0.groupCount && vMember0.groupCount.$anyError) {
          this.isHaveMaxTravelersError = true
          if (!vMember0.groupCount.required || !vMember0.groupCount.minValue)
            this.maxTravelersError.push(
              parseTranslate(this.translations.minimumNumberTravelersMinError.text, MIN_TRAVELERS)
            )
          else if (!vMember0.groupCount.maxValue)
            this.maxTravelersError.push(parseTranslate(this.translations.numberTravelersMaxError.text, MAX_TRAVELERS))
        }
      },

      checkPriceError(data) {
        if (data.$anyError) {
          if ((!data.price.required || !data.price.minValue) && !this.isHaveMinPriceError) {
            this.isHaveMinPriceError = true
            this.priceError.push(parseTranslate(this.translations.suggestedRetailPriceGreaterError.text, MIN_PRICE))
          } else if (!data.price.maxValue && !this.isHaveMaxPriceError) {
            this.isHaveMaxPriceError = true
            this.priceError.push(parseTranslate(this.translations.suggestedRetailPriceLessError.text, MAX_PRICE))
          }
        }
      },

      checkAgeError(data, member) {
        // Подавляем сбор общих сообщений об ошибках диапазонов во время редактирования.
        // Показываем агрегированную ошибку только при явном сохранении (this.submitting = true)
        if (!this.submitting) return
        if (data && data.$anyError) {
          const hasValidationErrors =
            !data.minAge?.required ||
            !data.minAge?.minValue ||
            !data.minAge?.maxValue ||
            !data.minAge?.lessThanMax ||
            !data.minAge?.noGaps ||
            !data.maxAge?.required ||
            !data.maxAge?.minValue ||
            !data.maxAge?.maxValue ||
            !data.maxAge?.greaterThanMin ||
            !data.maxAge?.noOverlap ||
            !data.maxAge?.fullCoverage ||
            !data.maxAge?.maxByTravelers

          if (hasValidationErrors && !this.isHaveAgeError) {
            this.isHaveAgeError = true

            // Определяем конкретный тип ошибки для более точного сообщения
            let errorMessage = ''

            // Типы ошибок в порядке приоритета
            if (!data.minAge?.noGaps) {
              errorMessage =
                this.translations.travelerRangeGapError?.text ||
                'Please enter a minimum number of travelers that is one greater than the maximum of the previous tier.'
            } else if (!data.maxAge?.noOverlap) {
              errorMessage = this.translations.travelerRangeOverlapError?.text || 'Ranges must not overlap.'
            } else if (!data.maxAge?.fullCoverage) {
              const maxTickets = this.getMaxTickets() || MAX_TRAVELERS
              errorMessage = parseTranslate(
                this.translations.travelerRangeFullCoverage?.text || 'Last range must end at {0}.',
                maxTickets
              )
            } else if (!data.minAge?.lessThanMax || !data.maxAge?.greaterThanMin) {
              errorMessage =
                this.translations.travelerRangeOrderError?.text ||
                'Please enter a maximum number of travelers greater than or equal to the minimum.'
            } else if (!data.maxAge?.maxByTravelers) {
              const maxTickets = this.getMaxTickets() || MAX_TRAVELERS
              errorMessage = parseTranslate(
                this.translations.travelerCountExceedsLimit?.text ||
                  'Please enter a maximum number of travelers less than or equal to {0}.',
                maxTickets
              )
            } else if (!data.minAge?.required || !data.maxAge?.required) {
              errorMessage = this.translations.travelerRangeRequired?.text || 'Both min and max are required.'
            } else if (!data.minAge?.minValue || !data.maxAge?.minValue) {
              const categoryName = member?.age_category?.name || ''
              errorMessage = parseTranslate(
                this.translations.travelerRangeMinValue?.text ||
                  'Select 0 as the minimum, unless you require a specific number of {0} in each booking.',
                categoryName
              )
            } else if (!data.minAge?.maxValue || !data.maxAge?.maxValue) {
              const maxTickets = this.getMaxTickets() || MAX_TRAVELERS
              errorMessage = parseTranslate(
                this.translations.travelerRangeMaxValue?.text ||
                  'Please enter a maximum number of travelers less than or equal to {0}.',
                maxTickets
              )
            } else {
              errorMessage = this.getTravelerCountErrorMessage()
            }

            // Проверяем, нет ли уже такого сообщения
            if (!this.ageError.includes(errorMessage)) {
              this.ageError.push(errorMessage)
            }
          }
        }
      },

      save() {
        this.submitting = true
        this.$v.$touch()

        let haveActiveMember = false
        let haveActiveDays = false
        let haveError = false
        this.errorsArray = []

        this.priceError = []
        this.ageError = []
        this.isHaveMinPriceError = false
        this.isHaveMaxPriceError = false
        this.isHaveAgeError = false
        this.isHaveAgeIntervalError = false
        this.specialOfferMinPriceError = false
        this.isHaveInitialMinSumError = false
        this.initialMinSumError = []

        if (this.tour.is_group_pricing) {
          haveActiveMember = this.priceOptionLocal.members[0].is_active = true
          this.checkRetailPrice()
          this.checkMaxTravelersError()
          if (this.isEdit) this.checkSpacialOffer(this.priceOptionLocal.members[0])
          this.checkInitialMinSum()
          haveError = this.isHaveMaxTravelersError || this.isHavePriceError || this.isHaveInitialMinSumError
        } else {
          for (let i = 0; i < this.priceOptionLocal.members.length; i++) {
            if (this.priceOptionLocal.members[i].is_active) {
              haveActiveMember = true
              if (this.priceOptionLocal.tieredPricing) {
                for (let j = 0; j < this.priceOptionLocal.members[i].ageTieredGroups.length; j++) {
                  if (this.isEdit) this.checkSpacialOffer(this.priceOptionLocal.members[i].ageTieredGroups[j])
                  this.checkPriceError(
                    this.$v.priceOptionLocal.members.$each.$iter[i].ageTieredGroups.$each.$iter[j]
                  )
                  this.checkAgeError(
                    this.$v.priceOptionLocal.members.$each.$iter[i].ageTieredGroups.$each.$iter[j],
                    this.priceOptionLocal.members[i]
                  )
                }
              } else {
                if (this.isEdit) this.checkSpacialOffer(this.priceOptionLocal.members[i])
              }
            }
          }
          if (!this.priceOptionLocal.tieredPricing) this.recomputePriceErrorsNonTiered()
          this.checkInitialMinSum()
          haveError = haveError || this.isHaveInitialMinSumError
        }

        for (const i in this.priceOptionLocal.days) {
          if (this.priceOptionLocal.days[i].is_active) {
            haveActiveDays = true
            break
          }
        }

        if (this.priceOptionLocal.openingHours) {
          for (const i in this.priceOptionLocal.openingScheduleTimes) {
            if (
              this.priceOptionLocal.openingScheduleTimes[i].startTime == null ||
              this.priceOptionLocal.openingScheduleTimes[i].startTime === '' ||
              this.priceOptionLocal.openingScheduleTimes[i].endTime == null ||
              this.priceOptionLocal.openingScheduleTimes[i].endTime === ''
            ) {
              haveError = true
              break
            }
          }
        }
        if (this.priceOptionLocal.addTimes) {
          for (const i in this.priceOptionLocal.anotherTimes) {
            if (
              this.priceOptionLocal.anotherTimes[i].time == null ||
              this.priceOptionLocal.anotherTimes[i].time === ''
            ) {
              haveError = true
              break
            }
          }
        }

        if (
          !this.$v.$anyError &&
          haveActiveMember &&
          haveActiveDays &&
          !haveError &&
          (this.step > 0 || !this.isSpacialOfferNow) &&
          !this.specialOfferMinPriceError
        ) {
          this.$emit('save', this.priceOptionLocal)
        } else {
          this.errors = true
          if (!haveActiveMember) this.errorsArray.push({ text: this.translations.error1.text })
          if (!haveActiveDays) this.errorsArray.push({ text: this.translations.error4.text })
          if (haveError) this.errorsArray.push({ text: this.translations.error5.text })
          if (this.isSpacialOfferNow) {
            this.specialOfferError = true
            this.errors = false
          }
          if (this.specialOfferMinPriceError) {
            this.errorsArray.push({
              text: this.translations.pricesCannotBeLowerThanPrediscount.text + this.tour.price_without_discount,
            })
          }
          if (this.isHaveInitialMinSumError) {
            this.errorsArray.push({
              text:
                this.translations?.initialMinSumExceedsLimitShort?.text ||
                'The sum of minimums across age groups exceeds your maximum travelers.',
            })
          }
        }

        this.submitting = false
      },
    },
  }
</script>

<style lang="scss">
  .add-prices-pop-up {
    &__title {
      margin-bottom: 23px;
      font-weight: bold;
      font-size: 32px;
      line-height: 48px;
    }

    &__pricing-title {
      margin-bottom: 17px;
      font-weight: bold;
    }

    &__block {
      padding: 34px 30px 32px 21px;
      background: #f9f9f9;
      border: 1px solid #ececec;
      border-radius: 4px;
      width: 100%;
      margin-bottom: 47px;
    }

    &__info-banner {
      background-color: white;
      border-color: $orange;
      margin-bottom: 40px;
      color: $orange;

      svg {
        min-width: 27px;
      }

      .error-banner {
        &__item {
          &:before {
            content: none !important;
          }
        }
      }
    }

    &__tiered-pricing {
      margin-bottom: 17px;
      display: flex;
      align-items: center;
      color: $gray-three;

      .switcher {
        margin-right: 10px;
      }
    }

    &__spacial-offer-error {
      margin-top: -50px;
      color: $red;
      margin-bottom: 20px;
    }

    &__get-paid {
      .question-mark__description {
        margin-left: -200px;
      }
    }

    &__apply-days {
      margin-bottom: 43px;

      &--title {
        margin-bottom: 8px;
        font-weight: bold;
      }
    }

    &__apply-days-content {
      display: flex;
      margin-top: 20px;

      &--item {
        &:not(:last-child) {
          margin-right: 10px;
        }
      }

      .inactive-date {
        background: $gray !important;
      }
    }

    &__apply-time {
      &--title {
        margin-bottom: 2px;
        font-weight: bold;
      }

      &--note {
        margin-bottom: 7px;
      }
    }

    &__apply-time-item {
      position: relative;
      margin-bottom: 10px;
      margin-right: 10px;

      &--delete {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 2;
        margin-left: -27px;
        width: 22px;
        height: 22px;
        background: $white;
      }

      &--error {
        z-index: 4;
        position: absolute;
        top: -65px;
        left: 0;
        background: $white;
        padding: 8px;
        min-width: 170px;
        border-radius: 10px;
        font-size: 15px;
        border: 1px solid $red;
        box-shadow: 0px 2px 8px rgba(30, 40, 67, 0.1);
      }
    }

    &__opening-time {
      &--title {
        margin-bottom: 20px;
        font-weight: bold;
      }

      &--edit-expand {
        display: flex;
        align-items: center;

        &--item {
          &:not(:last-child) {
            margin-right: 8px;
          }
        }

        margin-bottom: 15px;
      }
    }

    &__del_cross {
      cursor: pointer;
      margin-left: 5px;
    }

    &__del-price {
      cursor: pointer;
      margin-right: -15px;
      margin-left: 5px;
    }

    &__del-opening-schedule-times {
      margin-left: 10px;
      cursor: pointer;
    }

    &__add-input {
      cursor: pointer;
      color: $primary;
      font-weight: bold;
    }

    &__add-time {
      display: flex;
      align-items: center;
      margin-top: 10px;
      cursor: pointer;
      font-weight: bold;
      color: $primary;
      margin-bottom: 84px;
    }

    &__nav {
      border-top: 1px solid #ececec;
      padding-top: 23px;
      display: flex;
      justify-content: space-between;

      .v-btn {
        width: 150px;
        min-width: 150px;
      }
    }

    .custom-detepicker {
      width: 130px;
      z-index: 1;
    }

    &__errors {
      margin-bottom: 17px;
      padding: 23px 18px 18px 67px;
      width: 750px;
      position: relative;
      border: 2px solid #d80007;
      border-radius: 14px;

      &--icon {
        transform: rotate(180deg);
        position: absolute;
        left: 21px;
        top: 18px;
        width: 32px;
        height: 32px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      &--title {
        margin-bottom: 10px;
        font-weight: bold;
      }

      &--description {
        width: 675px;
      }

      &--error-type {
        display: flex;
        align-items: flex-start;

        &:not(:last-child) {
          margin-bottom: 5px;
        }
      }

      &--dot_red {
        margin-top: 6px;
        background: #d80007;
      }
    }

    .error-banner {
      margin-bottom: 15px;
      margin-top: 0px;
    }
  }

  .price-option {
    &__members-row {
      display: grid;
      grid-template-columns: 100px auto;
      gap: 20px;

      .v-input {
        margin-top: 0 !important;
        width: 100%;

        input {
          margin-top: 0 !important;
        }
      }

      .v-input__prepend-text {
        margin-top: 0 !important;
      }

      &:not(:first-child) {
        margin-bottom: 20px;
      }

      &--group {
        grid-template-columns: 235px 235px 235px;
      }
    }

    &__members-subrow {
      display: grid;
      grid-template-columns: 300px 300px;
      gap: 20px;
    }

    &__members-tiered-subrow {
      display: grid;
      grid-template-columns: 140px 225px 225px;
      gap: 20px;
    }

    &__member-description {
      width: 100%;
      font-size: 12px;
      line-height: 14px;
      color: #888a93;
    }

    &__members-cell {
      display: flex;
      align-items: center;
      height: 48px;

      &--tiered {
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        height: auto;
        gap: 20px;
      }

      input:disabled {
        text-align: right;
      }
    }
  }
</style>
